import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components

import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem.js'
import CardHeader from 'components/Card/CardHeader'
import CardBody from 'components/Card/CardBody'
import Card from 'components/Card/Card'

import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark'

import styles from 'assets/jss/material-kit-react/views/servicePageSections/consultStyle.js'

const useStyles = makeStyles(styles)

export default function ConsultSection(props) {
  const classes = useStyles()
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>
            <CollectionsBookmarkIcon className={classes.titleIcon} />
            咨询板块
          </h2>
        </GridItem>
      </GridContainer>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="success" className={classes.cardHeader}>
              <h4>绿色建筑标识认证咨询</h4>
            </CardHeader>
            <CardBody>
              <ul className={classes.cardBodyContainer}>
                <li>绿色建筑设计/运行标识认证咨询</li>
                <li>健康建筑设计/运行标识认证咨询</li>
                <li>创新奖/政府奖补资金申报咨询</li>
                <li>美国 LEED 标识认证咨询</li>
                <li>被动房建筑设计方案咨询</li>
              </ul>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="success" className={classes.cardHeader}>
              <h4>既有建筑绿色化改造技术咨询</h4>
            </CardHeader>
            <CardBody>
              <ul className={classes.cardBodyContainer}>
                <li>南京市机关事务管理局技术支撑单位</li>
                <li>既有建筑绿色改造设计/运行标识认证</li>
                <li>能源审计报告和水平衡测试报告</li>
                <li>既有建筑绿色改造方案编制</li>
                <li>建筑能耗和节能率核定报告</li>
                <li>示范项目奖补资金申报咨询</li>
              </ul>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="success" className={classes.cardHeader}>
              <h4>区域绿建规模化建设全过程咨询</h4>
            </CardHeader>
            <CardBody>
              <ul className={classes.cardBodyContainer}>
                <li>国家/省级绿色建筑示范城区创建全过程服务</li>
                <li>绿色生态专项规划编制</li>
                <li>绿色生态城区规划建设技术支撑服务咨询</li>
              </ul>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  )
}
